/* global Vue */
//import Vue from 'vue'
import App from './App.vue';
//
new Vue({
	el: '#filters',
	render: h=>h(App)
});
//EOF//